/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, entity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { LetterTemplateAvailabilityDto, LetterTemplateAvailabilityRequestDto } from './job-letters.model';

@Injectable()
export class JobLettersRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  update(letterTemplate: LetterTemplateAvailabilityRequestDto): Observable<LetterTemplateAvailabilityRequestDto> {
    return this.httpPut(
      `${this.bp}/letter-templates/availability`,
      letterTemplate,
      entity<LetterTemplateAvailabilityRequestDto>());
  }

  findAll(): Observable<LetterTemplateAvailabilityDto> {
    return this.httpGet(`${this.bp}/letter-templates/availability`, entity<LetterTemplateAvailabilityDto>());
  }
}
